module.exports = __webpack_public_path__ + "static/media/inf_dec_ext.56c7709a.png";